import { render, staticRenderFns } from "./CvCertificates.vue?vue&type=template&id=39fc41a8&scoped=true"
import script from "./CvCertificates.vue?vue&type=script&lang=js"
export * from "./CvCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fc41a8",
  null
  
)

export default component.exports